export default __webpack_public_path__ + "static/media/peoplePage.c5df0895.png";